import React, { Fragment } from 'react';
import '../../css/components/vehicleFilters/listFilter.css';
import Traductor from '../Traductor';
const ListFilter = ({
    filterTitle,
    itemList,
    filterName,
    filterContainer,
    filters,
    selectFilter,
    isMultiSelect,
}) => {
    const t = new Traductor();
    const renderList = () => {
        if (itemList != undefined && itemList.length > 0) {
            let printList = [];

            itemList.map((item, index) => {
                let checked = '';
                if (
                    filters[filterName] != null &&
                    filters[filterName].indexOf(item.Id) > -1
                ) {
                    checked = true;
                }

                printList.push(
                    <li
                        id={'list-filter-' + filterTitle + '__' + item.Id}
                        brand={item.Id}
                        key={index}
                    >
                        <label className="c-checkbox">
                            <input
                                id={
                                    filterName +
                                    (filterContainer ? filterContainer : '') +
                                    +'_' +
                                    index
                                }
                                className="c-checkbox__input"
                                type="checkbox"
                                name={filterName}
                                checked={checked}
                                onChange={e =>
                                    selectFilter(
                                        e.currentTarget.name,
                                        item.Id,
                                        isMultiSelect
                                    )
                                }
                            ></input>
                            <span className="c-checkbox__label ">
                                {t.getTraduction(item.Description)}
                            </span>
                            {/* newItem */}
                        </label>
                    </li>
                );
            });
            return <ul className="filter-list">{printList}</ul>;
        }
    };

    return (
        <Fragment>
            <div className="c-accordion__header  js-accordion__title c-vehicle-filters__item-title">
                <span className="c-accordion__title-icon"></span>
                <h3 className="c-accordion__title">
                    <button
                        className="c-accordion__title-label  js-accordion__title-label"
                        aria-expanded="true"
                        type="button"
                    >
                        <span className="c-accordion__title-label-text ">
                            {filterTitle}
                        </span>
                    </button>
                </h3>
            </div>
            <div
                className="c-accordion__panel  js-accordion__panel c-vehicle-filters__item-content"
                aria-hidden="true"
            >
                <div
                    className={
                        'c-accordion__content c-vehicle-filters__' + filterName
                    }
                >
                    {renderList()}
                </div>
            </div>
        </Fragment>
    );
};

export default ListFilter;
